import { gql } from '@apollo/client';

/**
 * GraphQL query for fetching community groups with nested communities
 * This optimized query fetches all data in a single request using BFF aggregation
 */
export const GET_COMMUNITY_GROUPS_WITH_COMMUNITIES = gql`
  query GetCommunityGroupsWithCommunities {
    communityGroupsWithCommunities {
      communityGroups {
        id
        name
        description
        userRole
        roles
        communities {
          id
          name
          communityGroupId
          userRole
          roles
          logoUrl
          optionalMetadata {
            bigId
          }
        }
      }
      isAdmin
    }
  }
`;

/**
 * Legacy queries - kept for backward compatibility
 * These are used by the old NavigationSlideout component
 */
export { GET_COMMUNITY_GROUPS } from '@communities/community-groups/graphql';
export { GET_COMMUNITIES_IN_GROUP } from '@communities/community/graphql';
